module.exports = __webpack_public_path__ + "img/weissrotunten.d8348a8a.jpg";